import UserModel from 'src/models/UserModel';
import { createTokenStore } from './tokenStore';

const { getToken, clearToken } = createTokenStore({
  getExchangeUrl: () => '/is-stripe/token/exchange',
  getParseToken: () => UserModel.getInstance().sessionToken
});

export const getStripeToken = getToken;
export const clearStripeToken = clearToken;
